import { ComponentStyleConfig } from "@chakra-ui/react";

const Menu: ComponentStyleConfig = {
  baseStyle: { list: { rounded: "none", shadow: "sm" } },
};

export default Menu;
